import { TokenParams } from '@longnecktech/splash-commons-fe';

export interface ITokenParams extends TokenParams {
  language?: string;
}

export function getTokenParams(): ITokenParams {
  const url = new URL(window.location.href);
  const queryParams = new URLSearchParams(url.search);
  return {
    token: queryParams.get('token') ?? '',
    instance: queryParams.get('instance') ?? '',
    gameUuid: queryParams.get('gameUuid') ?? '',
    language: queryParams.get('language') ?? '',
  };
}
